var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"ny-rute"},on:{"click":_vm.onClick}},[_c('span',[_vm._v("Opret en ny rute")]),_c('Plus')],1)}
var staticRenderFns = []

export { render, staticRenderFns }